import SiteDesignStore from "../stores/SiteDesignStore";
import ActiveBlockContainerStore from "../stores/ActiveBlockContainerStore.mjs";
import AppConstants from "../constants/AppConstants";

import { List } from "immutable";

const { VALUE_THIS } = AppConstants;

export const isBlockTargetValid = (value) =>
  Array.from(ActiveBlockContainerStore.getContainer()?.get("blocks") ?? List()).some(
    (block) => block.get("slug") === value
  ) || value === VALUE_THIS;

export const isPageTargetValid = (value) =>
  Array.from(SiteDesignStore.getPageList() ?? List()).some((page) => page.get("slug") === value);
